import { useSite } from "../../context/SiteContext";
import { mediaSrc } from "../../lib/api";
import { useBrandImage } from "../../lib/brand";

const SIZES = { sm: "h-9", md: "h-12", lg: "h-16" };

// Supplied wordmark is a JPEG on black (no transparent original), so it always sits on a black plate.
export const Logo = ({ size = "md", plate = true }) => {
  const { settings } = useSite() || {};
  const brand = useBrandImage("logo");
  const custom = settings?.logo_url;
  return (
    <span className={`inline-flex items-center ${plate ? "rounded-[3px] bg-black px-1.5 py-1 ring-1 ring-gold/60" : ""}`} data-testid="site-logo">
      <img src={custom ? mediaSrc(custom) : brand.src} srcSet={custom ? undefined : brand.srcSet} sizes="240px"
        alt="CIArb Bahamas Branch" className={`${SIZES[size]} w-auto`} width={brand.width} height={brand.height} />
    </span>
  );
};
